import { useContext } from "react";
import { LoggerContext } from "./LoggerContext.js";
import { LogLevel } from "./types.js";
import "react/jsx-runtime";
function useLogger(prefix) {
  const { level } = useContext(LoggerContext);
  function logError(...args) {
    level >= LogLevel.error && console.error(...prefixArgs(prefix, ...args));
  }
  function logWarn(...args) {
    level >= LogLevel.warn && console.warn(...prefixArgs(prefix, ...args));
  }
  function logInfo(...args) {
    level >= LogLevel.info && console.log(...prefixArgs(prefix, ...args));
  }
  function logDebug(...args) {
    level >= LogLevel.debug && console.debug(...prefixArgs(prefix, ...args));
  }
  return { logError, logWarn, logInfo, logDebug };
}
function prefixArgs(prefix, ...args) {
  return prefix ? [prefix, ...args] : args;
}
export {
  useLogger
};
//# sourceMappingURL=useLogger.js.map
